import React, { Component, PropTypes } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

const photos = [
  { src: '../assets/images/center/22.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/21.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/20.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/19.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/18.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/17.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/16.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/15.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/14.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/13.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/12.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/11.jpg', width: 4, height: 3 },
  // { src: '../assets/images/center/10.jpg', width: 4, height: 3 },
  // { src: '../assets/images/center/9.jpg', width: 4, height: 3 },
  // { src: '../assets/images/center/8.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/7.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/6.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/4.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/3.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/2.jpg', width: 3, height: 4 },
  // { src: '../assets/images/center/1.jpg', width: 3, height: 4 },
];

export default class Center extends Component {
  constructor(props) {
    super(props)
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {

    return (
      <div className="col-sm-12">
        <h3>Centrul de recuperare</h3>
        <section className="category cc-articles">

          <div className="i" id="articles">
            {/* <h2 className="category__title category__title--lozenge"><span className="category__title__text">Centrul de recuperare</span></h2> */}
            <div className="item item--issue item--link">
              <p className="text-justify">Din dorinţa de a oferi  copiilor cu nevoi speciale din zona Huedin un loc unde să poată face recuperări cu ajutorul specialiştilor şi in condiţii optime, s-a născut idea infiinţării unui centru de recuperare. Astfel, am inceput un nou proiect. Am obţinut cu sprijinul Primăriei şi Consiliului Local Huedin un spaţiu pe care l-am renovat, amenajat si utilat cu toate cele necesare. Centrul dispune de două săli: o sală de gimnastică medical şi kineto-terapie, şi  o sală pentru ergo-terapie, logopedie, art-terapie, consiliere psihologica, melo-terapie. Toate terapiile sunt gratuite, oferite de Asociaţia Umanitara “Dreptul la viaţă” Huedin cu sprijinul specialiştilor voluntari. </p>
            </div>
          </div>
          <div className="item item--issue item--link">
            <Gallery photos={photos} onClick={this.openLightbox} />
            <Lightbox images={photos}
              onClose={this.closeLightbox}
              onClickPrev={this.gotoPrevious}
              onClickNext={this.gotoNext}
              currentImage={this.state.currentImage}
              isOpen={this.state.lightboxIsOpen}
            />
          </div>
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/Center/center.js